import { render, staticRenderFns } from "./EditManager.vue?vue&type=template&id=6bc057d0&scoped=true&"
import script from "./EditManager.vue?vue&type=script&lang=js&"
export * from "./EditManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc057d0",
  null
  
)

export default component.exports